/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
  AsyncResult,
  callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
} from "@msdyn365-commerce/retail-proxy";
// @ts-ignore
import * as EntityClasses from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g";
import * as DataServiceEntities from "./DataServiceEntities.g";

// @ts-ignore
function casesQuery(id?: number): DataServiceQuery {
  const key = id ? { Id: id } : null;
  return new DataServiceQuery(
    "Cases",
    "Cases",
    DataServiceEntities.CasesExtensionClass,
    key
  );
}

export function createGetAllCustomerCasesInput(
  customerEmail: string
): IDataServiceRequest {
  const query = casesQuery();
  return query.createDataServiceRequestForOperation(
    "GetAllCustomerCases",
    true,
    DataServiceEntities.AllCustomerCasesResponseExtensionClass,
    "false",
    {
      bypassCache: "none",
      returnEntity: "DataServiceEntities.IAllCustomerCasesResponse",
    },
    { customerEmail: customerEmail }
  );
}

export function getAllCustomerCasesAsync(
  context: IContext,
  customerEmail: string
): AsyncResult<DataServiceEntities.IAllCustomerCasesResponse> {
  const request = createGetAllCustomerCasesInput(customerEmail);
  return callActionOrExecute<DataServiceEntities.IAllCustomerCasesResponse>(
    request,
    context.callerContext
  );
}

export function createCreateCaseInput(
  caseDetails: DataServiceEntities.ICaseWithAttachment
): IDataServiceRequest {
  const query = casesQuery();
  return query.createDataServiceRequestForOperation(
    "CreateCase",
    true,
    DataServiceEntities.CreateCaseResponseExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.ICreateCaseResponse",
    },
    { caseDetails: caseDetails }
  );
}

export function createCaseAsync(
  context: IContext,
  caseDetails: DataServiceEntities.ICaseWithAttachment
): AsyncResult<DataServiceEntities.ICreateCaseResponse> {
  const request = createCreateCaseInput(caseDetails);
  return callActionOrExecute<DataServiceEntities.ICreateCaseResponse>(
    request,
    context.callerContext
  );
}

export function createUpdateCaseInput(
  caseDetails: DataServiceEntities.IUpdateCase
): IDataServiceRequest {
  const query = casesQuery();
  return query.createDataServiceRequestForOperation(
    "UpdateCase",
    true,
    DataServiceEntities.UpdateCaseResponseExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.IUpdateCaseResponse",
    },
    { caseDetails: caseDetails }
  );
}

export function updateCaseAsync(
  context: IContext,
  caseDetails: DataServiceEntities.IUpdateCase
): AsyncResult<DataServiceEntities.IUpdateCaseResponse> {
  const request = createUpdateCaseInput(caseDetails);
  return callActionOrExecute<DataServiceEntities.IUpdateCaseResponse>(
    request,
    context.callerContext
  );
}

export function createGetCaseNotesInput(caseId: string): IDataServiceRequest {
  const query = casesQuery();
  return query.createDataServiceRequestForOperation(
    "GetCaseNotes",
    true,
    DataServiceEntities.GetCaseNotesResponseExtensionClass,
    "false",
    {
      bypassCache: "none",
      returnEntity: "DataServiceEntities.IGetCaseNotesResponse",
    },
    { caseId: caseId }
  );
}

export function getCaseNotesAsync(
  context: IContext,
  caseId: string
): AsyncResult<DataServiceEntities.IGetCaseNotesResponse> {
  const request = createGetCaseNotesInput(caseId);
  return callActionOrExecute<DataServiceEntities.IGetCaseNotesResponse>(
    request,
    context.callerContext
  );
}

export function createGetSpecificCaseInput(
  specificCaseId: string
): IDataServiceRequest {
  const query = casesQuery();
  return query.createDataServiceRequestForOperation(
    "GetSpecificCase",
    true,
    DataServiceEntities.GetSpecificCaseResponseExtensionClass,
    "false",
    {
      bypassCache: "none",
      returnEntity: "DataServiceEntities.IGetSpecificCaseResponse",
    },
    { specificCaseId: specificCaseId }
  );
}

export function getSpecificCaseAsync(
  context: IContext,
  specificCaseId: string
): AsyncResult<DataServiceEntities.IGetSpecificCaseResponse> {
  const request = createGetSpecificCaseInput(specificCaseId);
  return callActionOrExecute<DataServiceEntities.IGetSpecificCaseResponse>(
    request,
    context.callerContext
  );
}

export function createGetLatestNoteInput(caseId: string): IDataServiceRequest {
  const query = casesQuery();
  return query.createDataServiceRequestForOperation(
    "GetLatestNote",
    true,
    DataServiceEntities.GetLatestNoteResponseExtensionClass,
    "false",
    {
      bypassCache: "none",
      returnEntity: "DataServiceEntities.IGetLatestNoteResponse",
    },
    { caseId: caseId }
  );
}

export function getLatestNoteAsync(
  context: IContext,
  caseId: string
): AsyncResult<DataServiceEntities.IGetLatestNoteResponse> {
  const request = createGetLatestNoteInput(caseId);
  return callActionOrExecute<DataServiceEntities.IGetLatestNoteResponse>(
    request,
    context.callerContext
  );
}
